import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const CONTACT = {
  phone: "+917992132123",
  whatsapp: "917992132123",
  brand: "The Quisine",
  full: "The Quisine — Cloud Kitchen & Caterers",
  location: "Kanpur, Uttar Pradesh",
};

export const api = axios.create({ baseURL: API, withCredentials: true });

export function imgUrl(storage_path) {
  if (!storage_path) return "";
  if (storage_path.startsWith("http")) return storage_path;
  return `${API}/files/${storage_path}`;
}

export function waLink(message) {
  return `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(message)}`;
}

export function waCustomerLink(phone, message) {
  const digits = String(phone || "").replace(/\D/g, "");
  const intl = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${intl}?text=${encodeURIComponent(message)}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
